import React from "react";
import { Section, Container, Heading, Card, CardInner } from "toddlar-ui";

const Step: React.FC<{ title: string; description: string; index: number }> = ({
  title,
  description,
  index,
}) => (
  <Card className="h-full">
    <CardInner className="relative py-6">
      <div className="absolute top-3 left-3 flex h-8 w-8 items-center justify-center rounded-full bg-brand-100 text-brand-700 font-semibold">
        {index}
      </div>
      <div className="text-center">
        <div className="font-semibold text-ink">{title}</div>
        <div className="text-sm text-ink-muted">{description}</div>
      </div>
    </CardInner>
  </Card>
);

const RegisterHero: React.FC = () => {
  return (
    <Section background="sand">
      <Container>
        <Heading size="display" className="text-ink text-center">
          Get started in 3 easy steps
        </Heading>
        <Heading as="p" size="lead" className="mt-2 text-ink-muted text-center">
          Choose your plan, sign up, and start borrowing!
        </Heading>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
          <Step
            index={1}
            title="Choose your plan"
            description="Pick the billing period and plan that fits your family."
          />
          <Step
            index={2}
            title="Sign up"
            description="Create your account in less than a minute."
          />
          <Step
            index={3}
            title="Start borrowing"
            description="Use points to order toys, delivered to your door."
          />
        </div>
      </Container>
    </Section>
  );
};

export default RegisterHero;
